// Сохранение в sessionStorage — привязано к вкладке. Каждый посетитель и каждая
// новая вкладка получают чистое состояние; во время игры (рефреш страницы)
// прогресс сохраняется. localStorage не подходит, т.к. был общим на весь
// браузер и переносил прогресс между сессиями.

// v6 — переход на sessionStorage; все старые ключи невалидны.
const KEY = 'follow-knight-save-v6';

export type BiomeId = 'biome1' | 'biome2';

// 4 артефакта: 2 в биоме 1 (археология), 2 в биоме 2 (абисс)
export type ArtefactId = 'a1' | 'a2' | 'a3' | 'a4';
export const ALL_ARTEFACTS: ArtefactId[] = ['a1', 'a2', 'a3', 'a4'];

export type SaveData = {
  biomeId: BiomeId;
  respawnX: number;
  respawnY: number;
  hp: number;
  soul: number;
  collectedArtefacts: ArtefactId[];
};

export const SaveSystem = {
  save(data: SaveData): void {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(data));
    } catch {
      // ignore
    }
  },

  load(): SaveData | null {
    try {
      const raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (
        (parsed?.biomeId === 'biome1' || parsed?.biomeId === 'biome2') &&
        typeof parsed?.respawnX === 'number' &&
        typeof parsed?.respawnY === 'number' &&
        typeof parsed?.hp === 'number' &&
        typeof parsed?.soul === 'number' &&
        Array.isArray(parsed?.collectedArtefacts)
      ) {
        return parsed;
      }
      return null;
    } catch {
      return null;
    }
  },

  clear(): void {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      // ignore
    }
  },
};
